import { withStyles } from '@material-ui/styles';
import TableRow from '@material-ui/core/TableRow';

const TableRowBody = withStyles(() => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#d0d7e7',
    },
    '&:nth-of-type(even)': {
      backgroundColor: '#e9ecf3',
    },
  },
}))(TableRow);

export default TableRowBody;
